import React, { Component } from 'react'
import { translate } from "react-translate"
import { Col } from 'react-bootstrap'

@translate("Services")
export default class Services extends Component {

  render () {

    const { services, t  } = this.props

    return (
      services.length > 0 ? (
        services[0].informacion_enabled ? (
          <div className="services-container">
            <div dangerouslySetInnerHTML={{__html:services[0].informacion}}></div>
          </div>
        ) : <div/>
      ) : <div/>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Services/index.js